import { render, staticRenderFns } from "./payment-form.vue?vue&type=template&id=055f650a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./payment-form.vue?vue&type=script&lang=ts"
export * from "./payment-form.vue?vue&type=script&lang=ts"
import style0 from "./payment-form.vue?vue&type=style&index=0&id=055f650a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f650a",
  null
  
)

export default component.exports